module.exports = __webpack_public_path__ + "media/images/form-status-rejected-e9bb1678.gif";